import { LETTER } from "../apiConstant";
import BaseApi from "../baseApi";

class LetterApi extends BaseApi {
  send(param) {
    return this.post(`${LETTER}/send`, param);
  }

  getPage(param) {
    return this.post(`${LETTER}/page`, param);
  }

  getMemberPage(param) {
    return this.post(`${LETTER}/members`, param);
  }

  getAllMemberIds(param) {
    return this.post(`${LETTER}/all/members/${param}`);
  }

  changeUnread(param) {
    return this.post(`${LETTER}/read`, param);
  }
}

export default LetterApi;
